import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-inline-profile',
  styles: [`.profile-image { font-size: 36px; color: white; }`],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
        <div class="profile" [ngClass]="{'profile-expanded':active}">
            <a href="#" (click)="onClick($event)">
                <i class="fa fa-user-circle-o profile-image"></i>
                <span class="profile-name">{{userFullname}}</span>
                <i class="fa fa-fw fa-caret-down"></i>
                <span class="profile-role">{{userLogin}}</span>
            </a>
        </div>

        <ul id="profile-menu" class="layout-menu" [@menu]="active ? 'visible' : 'hidden'">
            <ng-content select=".profile-menu-items"></ng-content>
            <li role="menuitem">
                <a href="#" [attr.tabindex]="!active ? '-1' : null">
                    <i class="fa fa-fw fa-sign-out"></i>
                    <span>Logout</span>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">Logout</div>
                </div>
            </li>
        </ul>
    `,
  animations: [
    trigger('menu', [
      state('hidden', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class AppProfileComponent {
  @Input() userFullname: string | undefined;
  @Input() userLogin: string | undefined;

  public active = false;

  onClick(event: MouseEvent): void {
    this.active = !this.active;
    event.preventDefault();
  }
}
